<template>
  <OapSlider v-if="hasRecommendations" theme="light">
    <ul class="oap-slider__list">
      <li v-for="item in items" :key="item.id" class="oap-slider__item">
        <OapCard :type="product" :item="item" :layouts="['in-slider']" />
      </li>
    </ul>
  </OapSlider>
</template>

<script>
import OapCard from './../../../../../OapCard/code/Scripts/components/OapCard.vue';
import OapSlider from './../../../../../OapSlider/code/Scripts/components/OapSlider.vue';

export default {
  name: 'ProductSliderModel',

  components: {
    OapCard,
    OapSlider,
  },

  props: {
    items: {
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
  },

  computed: {
    hasRecommendations() {
      return this.items?.length > 0;
    },
  },
};
</script>
